module.exports = __webpack_public_path__ + "img/dog_wave.8580bd78.png";